module.exports = __webpack_public_path__ + "img/Tessellate43.0f2d99e8.jpg";